import { render, staticRenderFns } from "./CompatCaptureModal.vue?vue&type=template&id=54b4280e&scoped=true&"
import script from "./CompatCaptureModal.vue?vue&type=script&lang=ts&"
export * from "./CompatCaptureModal.vue?vue&type=script&lang=ts&"
import style0 from "./CompatCaptureModal.vue?vue&type=style&index=0&id=54b4280e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b4280e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VLayout})
